import React from 'react';
import PropTypes from 'prop-types';

class ViewsIcon extends React.PureComponent {
	render() {
		const { width, height, fill } = this.props;

		const viewBox = [0, 0, width, height].join(' ');

		return (
			<svg width={width} height={height} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
				<title>Views</title>
				<g fill={fill} transform="translate(0.000000, -2.000000)">
					<path d="M6,2 C3.70727217,2 1.62810678,3.25437251 0.0938938325,5.2918073 C-0.0312979442,5.45872967 -0.0312979442,5.69193004 0.0938938325,5.85885241 C1.62810678,7.89874195 3.70727217,9.15311445 6,9.15311445 C8.29272783,9.15311445 10.3718932,7.89874195 11.9061062,5.86130715 C12.0312979,5.69438478 12.0312979,5.46118441 11.9061062,5.29426204 C10.3718932,3.25437251 8.29272783,2 6,2 Z M6.16446763,8.0951212 C4.64252838,8.19085609 3.38570114,6.93648358 3.48143602,5.4120896 C3.55998773,4.15526235 4.57870512,3.13654495 5.83553237,3.05799325 C7.35747162,2.96225836 8.61429886,4.21663087 8.51856398,5.74102485 C8.43755753,6.99539736 7.41884014,8.01411476 6.16446763,8.0951212 Z M6.08837067,6.9315741 C5.26848727,6.98312366 4.59097883,6.30806996 4.64498312,5.48818656 C4.68671372,4.81067812 5.23657564,4.26327094 5.91408407,4.21908561 C6.73396747,4.16753605 7.41147591,4.84258975 7.35747162,5.66247315 C7.31328628,6.34243633 6.76342436,6.88984351 6.08837067,6.9315741 Z" />
				</g>
			</svg>
		);
	}
}

ViewsIcon.defaultProps = {
	width: 12,
	height: 8,
	fill: '#8A8B8C',
};

ViewsIcon.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	fill: PropTypes.string,
};

export default ViewsIcon;



// WEBPACK FOOTER //
// ./src/components/shared/icons/viewsIcon.js